"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Item: {
      maxHeight: 264,
      // let it show 5 sub items at most
      overflowY: 'auto',
      // and scroll the rest
      '& .button': {
        backgroundColor: theme['$sidebar-background-color'],
        position: 'sticky',
        // do not scroll up as the list gets scrolled
        top: 0,
        // and keep this it the top
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 12,
        paddingRight: 12,
        '& a': {
          paddingTop: 12,
          paddingBottom: 12,
          marginLeft: 10,
          marginRight: 10,
          width: '100%',
          // truncate long text
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          '&:hover': {
            textDecoration: 'none'
          }
        },
        '& svg': {
          fontSize: 20
        },
        '&.active': {
          backgroundColor: theme['$sidebar-active-color'],
          '& a': {
            color: theme['$text-color']
          }
        },
        '&.expanded': {
          zIndex: 1 // and above sub items (weirdly does not work if put on .button !!!)

        }
      },
      '&.even > .button': {
        backgroundColor: theme['$sidebar-odd-color']
      }
    },
    Arrow: {
      border: '4px solid transparent',
      borderLeftColor: theme['$sidebar-arrow-color'],
      height: 0,
      marginLeft: function marginLeft(_ref) {
        var indentLevel = _ref.props.indentLevel;
        return indentLevel * 10;
      },
      '&.down': {
        borderLeftColor: 'transparent',
        borderTopColor: theme['$sidebar-arrow-color'],
        marginTop: 5
      }
    },
    Spacer: {
      width: 10,
      marginLeft: function marginLeft(_ref2) {
        var indentLevel = _ref2.props.indentLevel;
        return indentLevel * 10;
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map